<template>
  <a-row :gutter="20">
    <a-col :span="12">
      <project-dict-list @onSelect="onSelect"></project-dict-list>
    </a-col>
    <a-col :span="12">
      <project-dict-item-list :dict="dictRecord"></project-dict-item-list>
    </a-col>
  </a-row>
</template>

<script>
  import ProjectDictList from './ProjectDictList'
  import ProjectDictItemList from './ProjectDictItemList'
  export default {
    name: 'List',
    components: { ProjectDictItemList, ProjectDictList },
    data(){
      return{
        dictRecord:{}
      }
    },
    mounted(){

    },
    methods:{
      onSelect(record){
        this.dictRecord = record
      }
    }
  }
</script>

<style scoped>

</style>